"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const VRView_1 = __importDefault(require("./VRView"));
const isVRReady_1 = __importDefault(require("../../../../javascript/isVRReady"));
const Splash_1 = __importDefault(require("./Splash"));
const QRButton_1 = __importDefault(require("./QRButton"));
const MediaControls_1 = __importDefault(require("./MediaControls"));
const MotionSensorError_1 = __importDefault(require("../components/MotionSensorError"));
const StyledVRController = styled_components_1.default.div `
    width: 100%;
    height: 100%;
    background: antiquewhite;
    position: fixed;
    display: relative;
`;
const View = styled_components_1.default.div `
    width: 50%;
    height: 100%;
    position: absolute;
`;
const PrimaryView = (0, styled_components_1.default)(View) `
    left: 0;
    width: ${(props) => props.isFullscreen ? "100%" : "50%"};
`;
const SecondaryView = (0, styled_components_1.default)(View) `
    right: 0;
    display: ${(props) => props.isVisible ? "auto" : "none"};
`;
const Icon = styled_components_1.default.button `
    width: 50px;
    height: 50px;
    position: fixed;
    right: 20px;
    bottom: 8px;
`;
const VRButton = (0, styled_components_1.default)(Icon) `
    background-image: url("${require("../assets/vr-icon.svg")}");
`;
const FullscreenButton = (0, styled_components_1.default)(Icon) `
    background-image: url("${require("../assets/fullscreen-icon.svg")}");
    &:hover {
        filter: brightness(0.9);
    }
`;
const ExitFullscreenButton = (0, styled_components_1.default)(Icon) `
    background-image: url("${require("../assets/exit-fullscreen-icon.svg")}");
    display: ${(props) => props.isVisible ? "auto" : "none"};
    &:hover {
        filter: brightness(0.9);
    }
`;
const FullscreenWindow = styled_components_1.default.div `
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    pointer-events: ${(props) => props.isClickable ? "auto" : "none"};
    cursor: grab;
`;
const requestMotionDevicePermissionIfOnIOS = async (isMobile) => {
    if (window["DeviceOrientationEvent"] &&
        typeof window["DeviceOrientationEvent"].requestPermission ===
            "function") {
        return (
        // @ts-ignore
        DeviceOrientationEvent.requestPermission()
            // @ts-ignore
            .then((response) => {
            if (response == "granted") {
                return true;
            }
            return false;
        })
            .catch((e) => {
            console.error(`Permission to use gyroscope denied: ${e}`);
            return false;
        }));
    }
    else if (isMobile) {
        // Any other mobiles we want to use the gyro so return that we have permission.
        return true;
    }
    else {
        return false;
    }
};
class VRController extends react_1.Component {
    constructor(props) {
        super(props);
        this.simController = (0, react_1.createRef)();
        this.fullscreen = (0, react_1.createRef)();
        this.audio = (0, react_1.createRef)();
        this.secondaryViewer = (0, react_1.createRef)();
        this.componentDidMount = () => {
            document.addEventListener("keydown", (evt) => {
                // no hotkeys on splash screen
                if (this.state.splashVisible)
                    return;
                if (evt.key === " ")
                    this.togglePause();
            });
        };
        // play immediately if on mobile
        this.splashClick = () => {
            this.togglePause();
            requestMotionDevicePermissionIfOnIOS(this.state.isMobile)
                .then((hasPermission) => {
                this.setState({
                    splashVisible: false,
                    useGyro: hasPermission,
                });
            })
                .catch((e) => {
                this.setState({
                    splashVisible: false,
                    useGyro: false,
                });
            });
        };
        this.togglePause = () => {
            this.setState({
                isPaused: !this.state.isPaused,
            }, () => {
                if (this.state.media) {
                    if (!this.state.isPaused)
                        this.state.media.play();
                    else
                        this.state.media.pause();
                }
            });
        };
        this.goFullscreen = () => {
            if (this.fullscreen.current.requestFullscreen) {
                this.fullscreen.current.requestFullscreen();
                // Apparently screen.orientation events are asynchronous, so we'll need to have a delay on this call
                setTimeout(() => {
                    window.screen.orientation.lock("landscape");
                    this.setState({
                        isFullscreen: true,
                    });
                    if (document.addEventListener) {
                        document.addEventListener("webkitfullscreenchange", this.exitFullscreen, false);
                        document.addEventListener("mozfullscreenchange", this.exitFullscreen, false);
                        document.addEventListener("fullscreenchange", this.exitFullscreen, false);
                        document.addEventListener("MSFullscreenChange", this.exitFullscreen, false);
                    }
                }, 200);
            }
            else {
                // You're an iPhone user, web pages can't go fullscreen, it'd be nice to remove your Navbar...
                // But that would jeopardize Apple's walled garden approach
            }
        };
        // We need to set secondary view direction to that of primary
        this.getView = (event) => {
            const viewDirection = {
                yaw: event.yaw,
                pitch: event.pitch,
                roll: event.roll,
            };
            this.setState({
                viewDirection,
            });
        };
        // User exits stereo
        this.exitFullscreen = () => {
            this.setState({
                isStereoscopic: false,
            }, () => {
                this.setState({
                    isFullscreen: false,
                });
                if (window.screen.orientation)
                    window.screen.orientation.unlock();
                if (document.removeEventListener) {
                    document.removeEventListener("webkitfullscreenchange", this.exitFullscreen, false);
                    document.removeEventListener("mozfullscreenchange", this.exitFullscreen, false);
                    document.removeEventListener("fullscreenchange", this.exitFullscreen, false);
                    document.removeEventListener("MSFullscreenChange", this.exitFullscreen, false);
                }
            });
        };
        // User activates VR mode
        this.goStereo = () => {
            // each viewer can be moved independently, which means stereomode can have two differnt views
            // match their viewDirection, this won't change during Stereo mode as pointer-events are disabled
            if (this.state.viewDirection) {
                this.secondaryViewer.current.viewer.lookAt(this.state.viewDirection);
            }
            this.setState({
                isStereoscopic: true,
            }, this.goFullscreen);
        };
        this.exitStereo = () => {
            this.setState({
                isStereoscopic: false,
            });
        };
        this.viewerReady = (video) => {
            // Viewer has loaded the video or image and is ready
            // Keep audio if it's already loaded
            this.setState({
                viewerReady: true,
                media: video || this.state.media,
            });
        };
        this.onMouseDown = () => {
            // Pause/Play if we tap, but not if we drag
            let toggleVideo = setTimeout(() => {
                this.togglePause();
            }, 200);
            this.simController.current.addEventListener("mousemove", () => {
                clearTimeout(toggleVideo);
            }, toggleVideo);
        };
        this.audioMounted = () => {
            if (!this.audio.current)
                return;
            this.setState({
                media: this.audio.current,
            });
        };
        const isVR = (0, isVRReady_1.default)();
        // Android doesn't have access to orientation controls at stileapp.com
        // So redirect to the simulations s3 equivalent
        // Convert https://stileapp.com/simulations/... into https://stile-simulations.s3.ap-southeast-2.amazonaws.com/...
        // Unless we have specifically overridden it
        let mobileUrl = this.props.mobileURL;
        if (!mobileUrl) {
            let a = document.location.href.split("/");
            mobileUrl =
                "https://stile-simulations.s3.ap-southeast-2.amazonaws.com/" +
                    a.splice(4, a.length - 1).join("/");
        }
        this.state = {
            isMobile: isVR,
            isPaused: true,
            viewerReady: false,
            isStereoscopic: false,
            isFullscreen: false,
            splashVisible: true,
            useGyro: false,
            mobileUrl,
        };
    }
    render() {
        // currently there's a bug that stops videos from playing on iPhone, not sure what it is
        const dontPlayVideosOnIphone = !(/iPad|iPhone|iPod/.test(navigator.userAgent) && this.props.videoSrc);
        const isFirefox = /Firefox/.test(navigator.userAgent);
        const isIOS = [
            "iPad Simulator",
            "iPhone Simulator",
            "iPod Simulator",
            "iPad",
            "iPhone",
            "iPod",
        ].indexOf(navigator.platform) !== -1 ||
            // iPad on iOS 13 detection
            (navigator.userAgent.includes("Mac") && "ontouchend" in document);
        // If the user is using Firefox, direct them to use the platform's preferred browser
        // for a better experience.
        const splashMessage = isFirefox
            ? `Use your finger to look around. Open this page in ${isIOS ? "Safari" : "Google Chrome"} for a more immersive experience.`
            : undefined;
        // In stereoscopic mode, PrimaryView will share the screen with SecondaryView
        const view = this.state.isMobile ? (react_1.default.createElement(FullscreenWindow, { ref: this.fullscreen, isClickable: !this.state.isStereoscopic },
            react_1.default.createElement(PrimaryView, { isFullscreen: !this.state.isStereoscopic },
                react_1.default.createElement(VRView_1.default, { ...this.props, isPaused: this.state.isPaused, viewerReady: this.viewerReady, isStereoscopic: this.state.isStereoscopic, getView: this.getView, onMouseDown: this.onMouseDown, isMobile: this.state.isMobile, useGyro: this.state.useGyro })),
            // the secondary viewer uses the video element created by the primary
            (this.state.media || this.props.imgSrc) && (react_1.default.createElement(SecondaryView, { isVisible: this.state.isStereoscopic },
                react_1.default.createElement(VRView_1.default, { imgSrc: this.props.imgSrc, ref: this.secondaryViewer, masterVideo: this.state.media, isPaused: this.state.isPaused, viewerReady: this.viewerReady, isStereoscopic: this.state.isStereoscopic, exitStereo: this.exitStereo, isMobile: this.state.isMobile, getView: this.getView, useGyro: this.state.useGyro }))))) : (react_1.default.createElement(FullscreenWindow, { ref: this.fullscreen, isClickable: true },
            react_1.default.createElement(VRView_1.default, { imgSrc: this.props.imgSrc, videoSrc: this.props.videoSrc, audioSrc: this.props.audioSrc, isPaused: this.state.isPaused, viewerReady: this.viewerReady, onMouseDown: this.onMouseDown, isMobile: this.state.isMobile, useGyro: this.state.useGyro }),
            (this.props.videoSrc || this.props.audioSrc) &&
                this.state.media && (react_1.default.createElement(MediaControls_1.default, { togglePause: this.togglePause, media: this.state.media, isPaused: this.state.isPaused })),
            react_1.default.createElement(QRButton_1.default, { mobileURL: this.state.mobileUrl }),
            react_1.default.createElement(ExitFullscreenButton, { onClick: () => document.exitFullscreen(), isVisible: this.state.isFullscreen })));
        return (react_1.default.createElement(StyledVRController, { ref: this.simController },
            react_1.default.createElement(MotionSensorError_1.default, null),
            this.state.splashVisible && (react_1.default.createElement(Splash_1.default, { title: this.props.title, message: splashMessage, viewerReady: this.state.viewerReady, splashClick: this.splashClick, imgSrc: this.props.imgSrc, splashImage: this.props.splashImage })),
            view,
            this.state.isMobile &&
                !this.state.isStereoscopic &&
                dontPlayVideosOnIphone && (react_1.default.createElement(VRButton, { onClick: this.goStereo })),
            !this.state.isMobile && (react_1.default.createElement(FullscreenButton, { onClick: this.goFullscreen, alt: "Fullscreen" })),
            this.props.audioSrc ? (react_1.default.createElement("audio", { ref: this.audio, src: this.props.audioSrc, onLoadedMetadata: this.audioMounted })) : null));
    }
}
exports.default = VRController;
